import React, { useCallback } from 'react';
import { useTheme } from 'styled-components';
import { Card } from 'antd';
import { AppRoutes } from '@/routes';
import { useTranslate } from '@/translations';
import { faClipboardCheck, PageContainer, Title } from '@/ui/components';
import { ResponsesDataGrid } from './components/ResponsesDataGrid';

export const QuestionnaireResponses = () => {
  const { t } = useTranslate();
  const { accent } = useTheme();
  const responsePath = useCallback(
    (id: number) => `${AppRoutes.questionnaireResponses}/${id}`,
    [],
  );

  return (
    <PageContainer>
      <Title
        title={t('questionnaireResponses')}
        icon={faClipboardCheck}
        color={accent}
      />
      <Card>
        <ResponsesDataGrid responsePath={responsePath} />
      </Card>
    </PageContainer>
  );
};
